import type { PreviewDevice } from '../../../types/journeyTypes';

/*
WHERE DO THESE HARD-CODED VALUES COME FROM?

width/height: The width and height of the viewport for each type of device
              can be found easily online with a Google search (common knowledge).
    NOTE: Resolution is what you will usually find online, but what we care
          about it actually the viewport size.

    Resolution
    -----------------  =  Viewport (what we care about)
    Pixel Ratio


    Resolution: How many pixels are displayed on the screen, usually the stats you
                see listed about a given phone.

    Viewport: The width and height of the CSS pixels displayed on the screen.

    Pixel Ratio: How many screen pixels equals one CSS pixel.

    More details: https://medium.com/@flik185/understanding-device-resolution-for-web-design-and-development-3bb4a5183478

padding: These are each manually calculated depending on the exact image asset
         for the outline which Design has provided us.
    NOTE: We are leaving intentional space at the top/bottom of each device
          screen opening to account for browser/operating system navigation.
    - 'top'/'left' are used to determine where the Journey preview should start
      in relation to the outline image
    - 'bottom' is used to determine the correct height the preview iFrame should
      take up (total height minus bottom padding, see ScreenViewEditor)

backgroundSize: Again this is manually calculated depending on the exact image
                asset for the outline which Design has provided us.
                This sets the 'background-size' property, determining the width
                of the device outline image (when one number is passed to
                'background-size' is it dictating the width, and the height is
                calculated).
*/
const STANDARD_LEFT_PADDING = 18;

export const DEVICE_OUTLINES: Record<string, PreviewDevice> = {
  iPhoneX_XS: {
    width: 375,
    height: 812,
    padding: {
      top: 109,
      left: STANDARD_LEFT_PADDING,
      bottom: 150,
    },
    backgroundSize: 308,
    outlineImage: 'iPhoneX_XS.svg',
  },
  iPhone6_7_8_Plus: {
    width: 414,
    height: 736,
    padding: {
      top: 135,
      left: 30,
      bottom: 115,
    },
    backgroundSize: 367,
    outlineImage: 'iPhone6+_7+_8+.svg',
  },
  iPhone12Pro: {
    width: 360, // 390
    height: 779, // 844
    padding: {
      top: 100,
      left: STANDARD_LEFT_PADDING + 12,
      bottom: 110,
    },
    backgroundSize: 320,
    outlineImage: 'iPhone_12_Pro.svg',
  },

  iPhone14ProMax: {
    width: 365, // 430
    height: 791, // 932
    padding: {
      top: 85,
      left: STANDARD_LEFT_PADDING + 10,
      bottom: 110,
    },
    backgroundSize: 320,
    outlineImage: 'iPhone_14_Pro_Max.svg',
  },
  iPhoneSE: {
    width: 344, // 375
    height: 612, // 667
    padding: {
      top: 180,
      left: STANDARD_LEFT_PADDING + 12,
      bottom: 110,
    },
    backgroundSize: 310,
    outlineImage: 'iPhone_SE.svg',
  },
  iPhoneXR: {
    width: 344, // 414
    height: 744, // 896
    padding: {
      top: 95,
      left: STANDARD_LEFT_PADDING + 13,
      bottom: 110,
    },
    backgroundSize: 310,
    outlineImage: 'iPhone_XR.svg',
  },
  pixel7: {
    width: 375, // 412
    height: 712, // 783
    padding: {
      top: 150,
      left: STANDARD_LEFT_PADDING + 5,
      bottom: 110,
    },
    backgroundSize: 320,
    outlineImage: 'Pixel_7.svg',
  },
  samsungGalaxyS20Ultra: {
    width: 365, // 412
    height: 770, // 869
    padding: {
      top: 120,
      left: STANDARD_LEFT_PADDING + 4,
      bottom: 110,
    },
    backgroundSize: 310,
    outlineImage: 'Samsung_Galaxy_S20_Ultra.svg',
  },
  HuaweiP30: {
    width: 360,
    height: 810,
    padding: {
      top: 90,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 300,
    outlineImage: 'HuaweiP30.svg',
  },
  HuaweiMate20: {
    width: 360,
    height: 748,
    padding: {
      top: 80,
      left: STANDARD_LEFT_PADDING,
      bottom: 110,
    },
    backgroundSize: 300,
    outlineImage: 'HuaweiMate20.svg',
  },
};

export default [
  {
    value: 'iPhone12Pro',
    label: 'iPhone 12 Pro',
    ...DEVICE_OUTLINES.iPhone12Pro,
  },
  {
    value: 'iPhone14ProMax',
    label: 'iPhone 14 Pro Max',
    ...DEVICE_OUTLINES.iPhone14ProMax,
  },
  {
    value: 'iPhoneSE',
    label: 'iPhone SE',
    ...DEVICE_OUTLINES.iPhoneSE,
  },
  {
    value: 'iPhoneXR',
    label: 'iPhone XR',
    ...DEVICE_OUTLINES.iPhoneXR,
  },
  {
    value: 'samsungGalaxyS20Ultra',
    label: 'Samsung Galaxy S20 Ultra+',
    ...DEVICE_OUTLINES.samsungGalaxyS20Ultra,
  },
  {
    value: 'pixel7',
    label: 'Pixel 8',
    ...DEVICE_OUTLINES.pixel7,
  },
  {
    value: 'huaweiP30',
    label: 'Huawei P30 / P30 Pro',
    ...DEVICE_OUTLINES.HuaweiP30,
  },
  {
    value: 'huaweiMate20',
    label: 'Huawei Mate 20 / Mate 20 Pro',
    ...DEVICE_OUTLINES.HuaweiMate20,
  },
];
